__turbopack_context__.v({
  "error-msg": "menu-module-scss-module__UMNMvq__error-msg",
  "errorIcon": "menu-module-scss-module__UMNMvq__errorIcon",
  "hint": "menu-module-scss-module__UMNMvq__hint",
  "menu": "menu-module-scss-module__UMNMvq__menu",
  "menuItem": "menu-module-scss-module__UMNMvq__menuItem",
  "popover": "menu-module-scss-module__UMNMvq__popover",
});
